<style>
  .icon {
    float: right;
    cursor: pointer;
    font-size: 26px;
  }

  img {
    height: 5rem;
    width: 5rem;
  }

  .pointer {
    cursor: pointer;
  }

  .choose-program {
    width: 15rem;
    padding-bottom: 2rem;
  }

  mat-icon {
    font-size: 50px;
  }

  .bigImg img {
    height: 6rem;
    width: 6rem;
  }

  .img1 {
    height: 6rem;
    width: 6rem;
  }

  .align-img {
    margin-bottom: 15px !important;
  }
</style>

<div class="container dialog">
  <mat-icon (click)="closePopup()" class="icon">close</mat-icon>
  <!-- <i mat-button  (click)="closePopup()" class="fa fa-times"></i> -->
  <h1 class="mat-headline">Choose Program</h1>
  <hr />
  <div class="padding-20"></div>
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center center">
    <div fxFlex="50" class="text-center choose-program pointer align-img">
      <div class="text-center" (click)="closePopup()">
        <img src="../../assets/images/Bancom-Popup-Individual.png" routerLink="/individual-programs/overview"
          class="img1" />
      </div>
      <div class="bold pointer" routerLink="/individual-programs/overview">
        Individual Program
      </div>
    </div>
    <div fxFlex="50" class="text-center choose-program bigImg pointer">
      <div class="text-center" (click)="closePopup()">
        <img src="../../assets/images/Bancom-Popup-Corporate.png" routerLink="/corporate-programs/overview" />
      </div>
      <p routerLink="/corporate-programs/overview" class="pointer bold">
        Corporate Program
      </p>
    </div>
  </div>